<template>
  <div>
    <navbar/>
    <error-panel showInPopup="false" />
    <Spinner :loaded="loaded" />
    <main role="main" v-if="loaded">
        <div class="jumbotron" id="tl-jumbotron">
          <div class="container">
            <div class="row tl-link-block tl-link-block-header pb-1 mb-3">
              <h4 class="col-10">
                <span class="bi bi-cloud-arrow-up-fill text-info mr-2"/>
                <span>Imported bookmarks</span>
                <div>
                    <span class="tl-subtext-header">import job id: {{ this.importJobId }}</span>
                </div>
              </h4>
            </div>

            <div data-title="emptyState" v-if="!hasLinks" class="row tl-link-block p-4">
              <div class="col-sm-1 d-none d-sm-block">
                <i class="bi bi-emoji-astonished tl-emptystate-icon"></i>
              </div>
              <div class="col-sm-9 col-12">
                <div class="tl-link-title">
                  There doesn't seem to be anything here...
                </div>
                <div class="tl-link-small mt-3">
                  Could be an empty import?
                </div>
              </div>
            </div>

            <LinkList v-if="hasLinks" :links="links" :owner="this.$store.state.loggedInUserName"/>

            <PageNavigation :prevPageNumber="prevPageNumber"
                            :nextPageNumber="nextPageNumber"
                            @navigate="navigate($event)" />

          </div>
        </div>
    </main>
    <tlfooter v-if="loaded"/>
  </div>
</template>

<script>
import navbar from "@/components/NavBar";
import tlfooter from "@/components/Footer";
import ErrorPanel from "@/components/ErrorPanel";
import BackendClient from "@/rest/backend-client";
import Spinner from "@/components/Spinner";
import LinkList from "@/components/LinkList";
import PageNavigation from "@/components/PageNavigation";

export default {
  name: "ImportedBookmarks",
  components: { ErrorPanel, navbar, tlfooter, Spinner, LinkList, PageNavigation },
  props: ['importJobId', 'page'],
  data() {
    return {
      backendClient: new BackendClient(),
      loaded: false,
      links: null,
      prevPageNumber: null,
      nextPageNumber: null
    };
  },

  mounted() {
    this.backendClient.getLinksByImportJobId(this.importJobId, this.page).then(responseData => {
      this.links = responseData.links;
      this.prevPageNumber = responseData.prevPageNumber;
      this.nextPageNumber = responseData.nextPageNumber;
      this.loaded = true;
    });
  },

  computed: {
    hasLinks() {
      return this.links && this.links.length > 0;
    }
  },

  methods: {
  navigate(event){
      this.$router.push({ name: 'importedBookmarks', params: {page: event.pageNumber, importJobId: this.importJobId } });
    }
  }
};
</script>
<style>

</style>
